import { render } from "./CarDefectsPage.vue?vue&type=template&id=4903f0db"
import script from "./CarDefectsPage.vue?vue&type=script&lang=js"
export * from "./CarDefectsPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__